/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
enum WebtopType {
    FULL = 'webtop_full',
    NETWORK_ACCESS = 'webtop_na_only',
}
export default WebtopType;
